import { ContentType } from '@entries/content-types'
import ContentfulReviewDesktop from '@entries/contentful-review-desktop'
import ContentfulReviewMobile from '@entries/contentful-review-mobile'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulReview: Utils.EntryFC<Queries.ContentfulReviewFragment> = ({
  content,
}) => (
  <>
    <div className="hidden w-full laptop:block">
      <Entry
        content={content}
        mapping={{
          [ContentType.ContentfulReview]: ContentfulReviewDesktop,
        }}
      />
    </div>
    <div className="block w-full laptop:hidden">
      <Entry
        content={content}
        mapping={{
          [ContentType.ContentfulReview]: ContentfulReviewMobile,
        }}
      />
    </div>
  </>
)

export const query = graphql`
  fragment ContentfulReview on Contentful4VKja7XjbWkW4WeI4OqeUi {
    ...ContentfulEntry
    ...ContentfulReviewDesktop
    ...ContentfulReviewMobile
  }
`

export default withDisplayName(ContentfulReview, 'ContentfulReview')
